import ClubExam from './ClubExam';
import ExamPartResult from './ExamPartResult';

export default class ClubExamResult {
    static STATUS_FAILURE = 'failure';
    static STATUS_PENDING = 'pending';
    static STATUS_SUCCESS = 'success';

    constructor() {
        this.id = null;
        this.clubExam = null;
        this.examDate = null;
        this.status = null;
        this.note = null;
        this.member = null;
        this.dog = null;
        this.clubExamPartResults = null;
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        const clubExamResult = new ClubExamResult();
        clubExamResult.id = data.id;
        clubExamResult.clubExam = ClubExam.fromData(data.clubExam);
        clubExamResult.examDate = data.examDate;
        clubExamResult.status = data.status;
        clubExamResult.note = data.note;
        clubExamResult.isEditable = data.isEditable;
        clubExamResult.isDeletable = data.isDeletable;
        if (data.member) {
            clubExamResult.member = data.member;
        }
        if (data.dog) {
            clubExamResult.dog = data.dog;
        }
        if (data.clubExamPartResults) {
            clubExamResult.examPartResults = data.clubExamPartResults.map((part) => ExamPartResult.fromData(part));
        }

        return clubExamResult;
    }

    isPending() {
        return this.status === ClubExamResult.STATUS_PENDING;
    }

    isFailure() {
        return this.status === ClubExamResult.STATUS_FAILURE;
    }

    isSuccess() {
        return this.status === ClubExamResult.STATUS_SUCCESS;
    }

    serialize() {
        return {
            id: this.id,
            status: this.status,
            examDate: this.examDate,
            note: this.note,
            examPartResults: this.examPartResults.map((part) => part.serialize()),
        };
    }
}
